import Cliser from 'cliser';
import Config from 'config';
import extend from 'extend';
import Utils from 'utils';
import ObjectTransform from 'utils/ObjectTransform';
import Api from 'utils/api';

export default class ConfigModel extends Cliser.Model {

  properties() {
    return {
      config: null
    };
  }

  static loadConfigForDevice(deviceId/*, date*/) {

    // Get auth token
    return Cliser.LoginModel.getState()

      // Create server requests
      .then((user) => {
        return Promise.all([
          Api.request({
            url: Config.servers.api + '/devices/' + deviceId,
            token: user.token
          }),
          /*Api.request({
            url: Config.servers.data + '/data/' + deviceId + '/latest/image',
            token: user.token
          })*/
        ]);
      })
      // Create object
      .then((responses) => {
        //console.log(responses[1])
        this.config = {
          device: this.importDeviceConfig(responses[0]),
          //images: [responses[1]]
        };
        return this.config;
      });
  }

  static latestData() {

    let deviceId = this.config.device.id

    // Get auth token
    return Cliser.LoginModel.getState()

      // Create server requests
      .then((user) => {
        return Api.request({
          url: Config.servers.data + '/data/' + deviceId + '/latest/image',
          token: user.token
        })
      })
      // Create object
      .then((res) => {
        return res;
      });
  }

  static lifecycleState(id) {

    // Get auth token
    return Cliser.LoginModel.getState()
      .then((user) => {
        return Api.request({
          url: Config.servers.data + '/devices/find',
          body: {
            query: {
              deviceId: id
            },
            filter: {
              meta: 0,
              setting: 0,
            }
          },
          method: 'POST',
          token: user.token
        })
      })
      .then((res) => {
        return res && res[0];
      });
  }

  static premise(id) {
    // Get auth token
    return Cliser.LoginModel.getState()
      .then(() => {
        return Api.request({
          url: Config.servers.flowOneApi + '/premises/find',
          body: {
            query: {
              devices: id
            }
          },
          method: 'POST',
          apitoken: Config.apiKeys.flowOneApiKey
        })
      })
      .then((res) => {
        return res && res[0];
      });
  }

  static openServiceRequests(id){
    return Cliser.LoginModel.getState()
      .then(() => {
        return Api.request({
          url: Config.servers.flowOneApi + '/servicerequests/open/'+id,
          method: 'GET',
          apitoken: Config.apiKeys.flowOneApiKey
        })
      })
      .then((res) => {
        return res;
      });
  }

  static createServiceRequest(request){
    return Cliser.LoginModel.getState()
      .then(() => {
        return Api.request({
          url: Config.servers.flowOneApi + '/servicerequests/',
          body:request,
          method: 'POST',
          apitoken: Config.apiKeys.flowOneApiKey
        })
      })
      .then((res) => {
        return res;
      });
  }

  static unreliableMeter(params) {
    // Get auth token
    return Cliser.LoginModel.getState()
      .then(() => {
        return Api.request({
          url: Config.servers.flowOneApi + '/premises/unreliable-meter',
          body: params,
          method: 'POST',
          apitoken: Config.apiKeys.flowOneApiKey
        })
      })
      .then((res) => {
        return res && res[0];
      });
  }

  static saveImage(data, deviceId) {
    // Get auth token
    return Cliser.LoginModel.getState()
      .then((user) => {
        return Api.uploadFile({
          url: Config.servers.data + '/savefile/' + deviceId,
          data,
          method: 'POST',
          token: user.token
        })
      })
      .then((res) => {
        return res && res[0];
      });
  }

  static latestImageLink(deviceId) {
    return Api.request({
      url: Config.servers.data + '/lcp-data/' + deviceId + '/latest/image',
      method: 'GET'
    })
      .then((res) => {
        if (res && res.token) {
          return Config.servers.data + '/file/' + res.token;
        }
        return null;
      });
  }

  static saveSettingsToDevice(deviceId, settings, lifecycleState, saveImage, meta) {
    const config = this.exportDeviceConfig(
      extend(true,
        {},
        this.config,
        {
          device: {
            settings: settings
          }
        }
      )
    );

    const payload = config.device.settings
    payload.originator = "flowone-setup-assistant";
    payload.meta = meta;

    const serverConf = Config.servers;
    //const isProdTag = /^livion\/optiwater/.test(config.device.tag);
    //const flowOneUrl = isProdTag ? serverConf.flowOneApi : serverConf.flowOneTestApi;
    const apiConf = Config.apiKeys;
    //const apiKey = isProdTag ? apiConf.flowOneApiKey : apiConf.flowOneTestApiKey;
    const apiKey = apiConf.flowOneApiKey
    const flowOneUrl = serverConf.flowOneApi

    return Cliser.ImageModel.getImageData().then((file) => {
      // Get auth token
      return Cliser.LoginModel.getState()
        .then((user) => {
          const promises = [
            Api.request({
              url: serverConf.api + '/devices/' + deviceId + '/settings',
              method: 'POST',
              token: user.token,
              body: payload
            }),
            Api.request({
              url: flowOneUrl + '/deviceinstall/' + deviceId + '/configure',
              method: 'GET',
              apitoken: apiKey
            }),
          ];
          if (lifecycleState === 'delivered') {
            promises.push(
              Api.request({
                url: serverConf.data + '/devices/' + deviceId + '/lifecycle',
                method: 'POST',
                token: user.token,
                body: { state: 'active' }
              })
            );
          }
          if (file && saveImage) {
            promises.push(
              Api.uploadFile({
                url: serverConf.data + '/savefile/' + deviceId,
                data: {
                  settings,
                  file
                },
                method: 'POST',
                token: user.token
              })
            );
          }
          return Promise.all(promises).then((resArr) => {
            return resArr[0];
          })
        })
    });
  }

  static getSettings() {
    return Utils.getSafely(this, 'config.device.settings');
  }

  static savePublicNoteToMeta(meta, deviceId) {
    const serverConf = Config.servers;
    return Cliser.LoginModel.getState()
      .then((user) => {
        const promises = [
          Api.request({
            url: serverConf.api + '/devices/' + deviceId + '/meta',
            method: 'POST',
            token: user.token,
            body: JSON.parse(meta)
          })
        ];
        return Promise.all(promises).then((resArr) => {
          return resArr[0];
        })
      })
  }

 

 

  importDeviceConfig(config) {
    let transform = new ObjectTransform(config);
    transform.renamePropertyForEach('presicion', 'precision', 'settings.decimals.positions')
    transform.renamePropertyForEach('precicion', 'precision', 'settings.digits.positions')
    return transform.get();
  }

  exportDeviceConfig(config) {
    let transform = new ObjectTransform(config);
    transform.renamePropertyForEach('precision', 'presicion', 'settings.decimals.positions')
    return transform.get();
  }

}


// WEBPACK FOOTER //
// ./client/models/ConfigModel.js